import { InlineTextboxCell, InlineTextboxCellStore, IInlineTextboxCellProps } from './InlineTextboxCell';
import { observer } from 'mobx-react';
import { ViewMode } from './ViewMode';
import { TextCell } from './TextCell';
import { TextField } from 'office-ui-fabric-react';
import React from 'react';
import { Tooltip } from 'reactstrap';
import { observable, action } from 'mobx';

@observer
export class InlineTextboxCellWithTooltip<T extends { id?: string | undefined; }> extends InlineTextboxCell<T> {
    @observable tooltipOpen: boolean = false;
    ref: React.RefObject<HTMLDivElement> = React.createRef();
    container: Element | null = null;

    constructor(props: IInlineTextboxCellProps<T>) {
        super(props);
        this.props = props;
        this.store = new InlineTextboxCellStore(props);
    }

    @action.bound
    toggle() {
        this.tooltipOpen = !this.tooltipOpen;
    }

    componentDidMount() {
        if (this.ref.current) {
            this.container = this.ref.current.closest('.rt-tbody');
        }
    }

    componentDidUpdate(prevProps: IInlineTextboxCellProps<T>) {
        if (this.props.cellInfo.row.id !== prevProps.cellInfo.row.id) {
            this.tooltipOpen = false;
        }
    }

    render() {
        let id = 'tooltip_target_' + this.props.cellInfo.row.id;
        if (this.store.mode === ViewMode.view) {
            return (
                <div id={id} ref={this.ref}>
                    <TextCell value={this.store.value}
                        onDoubleClick={this.props.editOnDoubleClick && this.store.toEditMode || undefined}
                        onClick={!this.props.editOnDoubleClick && this.store.toEditMode || undefined} />
                    {this.props.cellInfo.value && this.container && <Tooltip container={this.container as HTMLElement} placement="left" isOpen={this.tooltipOpen} target={id} toggle={this.toggle}>
                        {this.props.cellInfo.value}
                    </Tooltip>}
                </div>
            );
        } else {
            return (
                <TextField
                    id={id}
                    onChange={this.store.onEdit}
                    onKeyDown={this.store.onKeyDown}
                    onBlur={this.store.onBlurHandler}
                    autoFocus={true}
                    value={this.store.value}
                    disabled={this.props.disabled}
                />
            );
        }
    }
}